<template>
    <b-modal
        :id="wishlist.uuid"
        :title="$t('wishlist.edit.modalTitle')"
        hide-footer
    >
        <b-form-group :label="$t('wishlist.edit.name')">
            <b-input v-model="wishlist.name"></b-input>
        </b-form-group>
        <b-form-group :label="$t('wishlist.edit.description')">
            <b-input v-model="wishlist.text"></b-input>
        </b-form-group>
        <hr class="mt-3 mb-3"/>
        <section class="wedding-edit-fields" v-if="wishlist.type === 'wedding' && wishlist.meta">
            <section class="edit-name-group">
                <b-form-group :label="$t('wishlist.edit.firstName')">
                    <b-input v-model="wishlist.meta.person1.firstName"></b-input>
                </b-form-group>
                <b-form-group :label="$t('wishlist.edit.lastName')">
                    <b-input v-model="wishlist.meta.person1.lastName"></b-input>
                </b-form-group>
            </section>
            <section class="edit-name-group">
                <b-form-group :label="$t('wishlist.edit.firstName')">
                    <b-input v-model="wishlist.meta.person2.firstName"></b-input>
                </b-form-group>
                <b-form-group :label="$t('wishlist.edit.lastName')">
                    <b-input v-model="wishlist.meta.person2.lastName"></b-input>
                </b-form-group>
            </section>
        </section>
        <b-form-group :label="$t('wishlist.edit.location')">
            <b-input v-model="wishlist.location"></b-input>
        </b-form-group>
        <b-form-group :label="$t('wishlist.edit.date')">
            <my-date-field v-model="wishlist.date"></my-date-field>
        </b-form-group>
        <b-form-group :label="$t('wishlist.edit.type')">
            <div v-if="wishlist.type !== 'wedding'">
                <v-select
                    v-model="wishlist.type"
                    :reduce="(opt) => opt.id"
                    :options="typeThemes"
                    :clearable="false"
                ></v-select>
            </div>
            <div v-else>
                {{ $t(`wishlist.typeTheme.${wishlist.type}`) }}
            </div>
        </b-form-group>
        <div class="split">
            <b-button
                size="sm"
                variant="outline-primary"
                @click="removeList(wishlist)"
            >
                {{ $t('wishlist.removeListButton') }}
            </b-button>
            <b-button
                size="sm"
                variant="primary"
                @click="saveWishlist(wishlist)"
            >{{ $t('wishlist.save') }}
            </b-button>
        </div>
    </b-modal>
</template>
<script>
import AlignRight from '@components/Layout/AlignRight.vue';
import { useWishlistStore } from '@stores/Wishlist';
import { defineComponent } from 'vue';
import MyDateField from '@components/Form/MyDateField.vue';

/**
 * @todo translate the hardcoded template text
 */
export default defineComponent({
    components: { MyDateField, AlignRight },
    data() {
        const wishlists = useWishlistStore();
        return {
            typeThemes: wishlists.getWishlistTypeThemes().map((item) => {
                item.label = this.$t(item.label);
                return item;
            }),
        };
    },
    props: {
        wishlist: {
            type: Object,
            default() {
                return null;
            }
        },
        open: {
            type: Boolean,
            default() {
                return false;
            },
        },
    },
    methods: {
        removeNullValues(obj) {
            return Object.fromEntries(Object.entries(obj).filter(([ _, value ]) => value !== null));
        },
        async saveWishlist(wishlist) {
            const store = useWishlistStore();

            let date = null;
            if (wishlist?.date?.length >= 0) {
                date = wishlist?.date;
            }

            try {
                const updated = await store.updateList(wishlist.id, {
                    ...this.removeNullValues(wishlist),
                    date,
                });
                this.$bvModal.hide(wishlist.uuid);
                this.$emit('wishlist-updated', updated);
            } catch (e) {
                console.log(e.response.data);
            }
        },
        async removeList(wishlist) {
            const store = useWishlistStore();
            try {
                await store.deleteList(wishlist.id);
                this.$emit('wishlist-deleted', wishlist.id);
                this.$bvModal.hide(wishlist.uuid);
            } catch (e) {
                console.log(e);
            }
        },
    },
});
</script>
<style lang="scss" scoped>
.split {
    display: flex;
    justify-content: space-between;
}

.wedding-edit-fields .edit-name-group {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
}
</style>
